import { type MultiLessonFlags } from "#/components/exam-results/types";
import { type MainResultSet } from "#/services/rest/gwt/exam-results/views/type-1/multi-user.types";
import { useMemo } from "react";
import MultiLessonCard from "./Card";
import styles from "./styles.module.scss";

type MultiLessonCardProps = {
  participantNo: number;
  data: MainResultSet[];
};

const MultiLessonCards = ({ data, participantNo }: MultiLessonCardProps) => {
  const flags = useMemo<MultiLessonFlags>(
    () => ({
      isMulti: participantNo > 1,
      hasTithe: participantNo >= 10
    }),
    [participantNo]
  );

  return (
    <div className={styles["multiLessonCards"]}>
      {data.map((card) => (
        <MultiLessonCard key={card.name} flags={flags} {...card} />
      ))}
    </div>
  );
};

export default MultiLessonCards;
